export const categories = [
  { slug: "romance", name: "恋爱言情", icon: "ri-heart-line", description: "甜蜜浪漫的爱情故事，心动时刻" },
  { slug: "fantasy", name: "奇幻冒险", icon: "ri-magic-line", description: "魔法与剑的奇幻世界，冒险启程" },
  { slug: "action", name: "热血动作", icon: "ri-fire-line", description: "激情澎湃的战斗场面，燃爆全场" },
  { slug: "thriller", name: "悬疑惊悚", icon: "ri-ghost-line", description: "扣人心弦的悬疑剧情，步步惊心" },
  { slug: "comedy", name: "搞笑日常", icon: "ri-emotion-laugh-line", description: "轻松幽默的日常生活，笑料不断" },
  { slug: "drama", name: "剧情深度", icon: "ri-film-line", description: "引人入胜的深刻故事，余韵悠长" },
  { slug: "historical", name: "古风历史", icon: "ri-ancient-gate-line", description: "穿越时空的古典美学，风华绝代" },
  { slug: "bl", name: "BL耽美", icon: "ri-user-heart-line", description: "细腻动人的情感描绘，心动不已" },
];

export const comics = [
  {
    id: 1,
    title: "恶女的逆袭",
    author: "Yeo-Ul",
    coverImage: "https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20cover%20art%20featuring%20an%20elegant%20female%20protagonist%20in%20a%20vintage%20gown%20with%20dramatic%20lighting%2C%20soft%20watercolor%20texture%2C%20warm%20color%20palette%2C%20manga%20illustration%20style%20with%20detailed%20eyes%20and%20flowing%20hair%2C%20clean%20composition%20on%20light%20cream%20background&width=400&height=560&seq=comic-cover-01&orientation=portrait",
    rating: 9.6,
    category: "romance",
    tags: ["恋爱", "复仇", "宫廷"],
    status: "连载中",
    updateDate: "2026-08-03",
    description: "被冤枉致死的公爵千金，带着记忆重生回到十五岁。这一次，她不会再做任人宰割的羔羊，而是要让所有背叛她的人付出代价。然而复仇之路上，那位冷酷的帝国皇子却一次次出现在她身边……",
    chapters: 128,
    views: 3250000,
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 2,
    title: "剑与魔法之塔",
    author: "Studio JBB",
    coverImage: "https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20cover%20illustration%20of%20a%20young%20warrior%20holding%20a%20glowing%20sword%20standing%20before%20a%20mysterious%20tower%2C%20fantasy%20setting%20with%20magical%20effects%2C%20vibrant%20colors%2C%20detailed%20armor%20design%2C%20anime%20art%20style%2C%20clean%20light%20background&width=400&height=560&seq=comic-cover-02&orientation=portrait",
    rating: 9.4,
    category: "fantasy",
    tags: ["奇幻", "冒险", "战斗"],
    status: "连载中",
    updateDate: "2026-08-03",
    description: "少年艾伦在村庄被毁后，独自踏上了攀登传说中魔法塔的旅程。每一层塔都有着不同的试炼和敌人，而塔顶据说藏着能够实现任何愿望的秘宝。在这个剑与魔法交织的世界里，他将结识伙伴、面对强敌、揭开身世之谜。",
    chapters: 96,
    views: 2890000,
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 3,
    title: "废柴逆天系统",
    author: "Lee Hyun",
    coverImage: "https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20style%20cover%20showing%20an%20ordinary%20student%20suddenly%20surrounded%20by%20holographic%20game%20interface%20elements%2C%20modern%20urban%20setting%2C%20dynamic%20action%20pose%2C%20cool%20blue%20and%20white%20color%20scheme%2C%20clean%20digital%20art%20style%20on%20light%20background&width=400&height=560&seq=comic-cover-03&orientation=portrait",
    rating: 9.3,
    category: "action",
    tags: ["系统", "战斗", "升级"],
    status: "连载中",
    updateDate: "2026-08-02",
    description: "全校最废柴的高中生金宇镇，在某天救下一只黑猫后，脑海中突然出现了逆天系统界面！从此他的人生彻底改变 —— 任务奖励、技能学习、属性加点……从默默无闻到横扫强敌，他的逆袭之路才刚刚开始。",
    chapters: 156,
    views: 4560000,
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 4,
    title: "暗夜追踪者",
    author: "Park Min-ji",
    coverImage: "https://readdy.ai/api/search-image?query=A%20moody%20Korean%20thriller%20webtoon%20cover%20featuring%20a%20detective%20in%20a%20trench%20coat%20standing%20in%20a%20rainy%20alley%20under%20a%20streetlamp%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20warm%20amber%20lighting%2C%20watercolor%20comic%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-04&orientation=portrait",
    rating: 9.5,
    category: "thriller",
    tags: ["悬疑", "推理", "犯罪"],
    status: "连载中",
    updateDate: "2026-08-01",
    description: "首尔连续发生离奇失踪案，刑警姜道贤被派往特别调查组。随着调查深入，他发现所有线索都指向十年前那桩被尘封的灭门案。真相如蛛网般复杂，而凶手似乎就在他的身边……",
    chapters: 72,
    views: 1980000,
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 5,
    title: "办公室罗曼史",
    author: "Choi Soo-young",
    coverImage: "https://readdy.ai/api/search-image?query=A%20sweet%20Korean%20romance%20webtoon%20cover%20showing%20a%20young%20man%20and%20woman%20in%20office%20attire%20sharing%20a%20coffee%20moment%2C%20warm%20sunlight%20streaming%20through%20windows%2C%20soft%20pastel%20colors%2C%20gentle%20romantic%20atmosphere%2C%20clean%20minimalist%20illustration%20on%20cream%20background&width=400&height=560&seq=comic-cover-05&orientation=portrait",
    rating: 9.2,
    category: "romance",
    tags: ["恋爱", "职场", "甜蜜"],
    status: "已完结",
    updateDate: "2026-07-28",
    description: "平凡实习生林秀雅意外发现自己暗恋的部门经理竟然也对她有好感。在繁忙的办公室日常中，一段甜蜜又充满波折的办公室恋情悄然展开。同事的八卦、项目的压力、职场的竞争……爱情能否经受住现实的考验？",
    chapters: 88,
    views: 2780000,
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 6,
    title: "爆笑学园日记",
    author: "Kim Potato",
    coverImage: "https://readdy.ai/api/search-image?query=A%20funny%20Korean%20school%20comedy%20webtoon%20cover%20with%20chibi%20style%20students%20in%20exaggerated%20funny%20expressions%2C%20bright%20and%20colorful%20art%20style%2C%20humorous%20classroom%20scene%2C%20cartoonish%20illustration%2C%20cheerful%20vibe%20on%20light%20yellow%20background&width=400&height=560&seq=comic-cover-06&orientation=portrait",
    rating: 9.1,
    category: "comedy",
    tags: ["校园", "搞笑", "日常"],
    status: "连载中",
    updateDate: "2026-08-03",
    description: "转学生李小北来到奇葩云集的星光学园，这个学校的学生一个比一个离谱 —— 中二病晚期患者、吃货属性全开、运动白痴的天才学霸……每一天都充满了意想不到的笑料和欢乐！",
    chapters: 204,
    views: 5120000,
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 7,
    title: "末路狂花",
    author: "Jung Hye-won",
    coverImage: "https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20webtoon%20cover%20of%20two%20women%20running%20through%20a%20wasteland%20at%20sunset%2C%20post-apocalyptic%20setting%2C%20emotional%20and%20powerful%20composition%2C%20warm%20golden%20hour%20lighting%2C%20detailed%20character%20art%2C%20clean%20dramatic%20illustration%20on%20neutral%20background&width=400&height=560&seq=comic-cover-07&orientation=portrait",
    rating: 9.7,
    category: "drama",
    tags: ["剧情", "女性", "生存"],
    status: "连载中",
    updateDate: "2026-08-02",
    description: "末世降临后，两个性格迥异的女人在废墟中相遇，不得不结伴求生。一个是冷静理智的前军医，一个是冲动热血的街头拳手。在残酷的末世中，她们的友情和信念将面临终极考验。",
    chapters: 64,
    views: 1650000,
    isHot: false,
    isNew: true,
    isRecommended: true,
  },
  {
    id: 8,
    title: "长安幻夜",
    author: "Moon Sook",
    coverImage: "https://readdy.ai/api/search-image?query=A%20beautiful%20historical%20Korean%20webtoon%20cover%20set%20in%20ancient%20China%20Tang%20dynasty%2C%20featuring%20a%20graceful%20woman%20in%20traditional%20hanfu%20under%20lantern%20light%2C%20elegant%20classical%20aesthetic%2C%20warm%20red%20and%20gold%20tones%2C%20detailed%20ink%20painting%20style%20on%20cream%20background&width=400&height=560&seq=comic-cover-08&orientation=portrait",
    rating: 9.8,
    category: "historical",
    tags: ["古风", "历史", "爱情"],
    status: "连载中",
    updateDate: "2026-08-01",
    description: "大唐盛世，长安城内暗流涌动。女扮男装的画师苏锦年意外卷入宫廷阴谋，与神秘刺客组织首领相遇。在繁华与危险并存的长安城中，他们的命运紧紧交织，一段跨越身份与时代的故事就此展开。",
    chapters: 112,
    views: 3670000,
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 9,
    title: "星河之下",
    author: "Team Starfish",
    coverImage: "https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20BL%20webtoon%20cover%20showing%20two%20young%20men%20looking%20at%20starry%20night%20sky%20together%20on%20a%20rooftop%2C%20gentle%20emotional%20connection%2C%20soft%20blue%20and%20purple%20night%20colors%2C%20beautiful%20atmospheric%20lighting%2C%20delicate%20illustration%20style%20on%20dark%20background&width=400&height=560&seq=comic-cover-09&orientation=portrait",
    rating: 9.4,
    category: "bl",
    tags: ["BL", "青春", "治愈"],
    status: "已完结",
    updateDate: "2026-07-15",
    description: "天文学社的两位男生，一个是沉默寡言的天才观测员，一个是阳光开朗的社团新人。在无数个仰望星空的夜晚中，两颗年轻的心逐渐靠近。星河之下，是属于他们二人的秘密宇宙。",
    chapters: 56,
    views: 2340000,
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 10,
    title: "拳皇之路",
    author: "Kang Do-sik",
    coverImage: "https://readdy.ai/api/search-image?query=A%20powerful%20Korean%20action%20webtoon%20cover%20of%20a%20fighter%20in%20boxing%20stance%20inside%20a%20ring%20with%20dramatic%20spotlight%2C%20intense%20action%20atmosphere%2C%20muscular%20art%20style%2C%20warm%20dramatic%20contrast%20lighting%2C%20dynamic%20composition%20on%20dark%20background&width=400&height=560&seq=comic-cover-10&orientation=portrait",
    rating: 9.3,
    category: "action",
    tags: ["格斗", "热血", "竞技"],
    status: "连载中",
    updateDate: "2026-08-03",
    description: "曾经的拳击天才崔泰浩因伤退役后一蹶不振，在街头靠打黑拳为生。一次偶然的机会，他遇到了改变他命运的老教练。重返正规拳坛的道路充满荆棘，但他已经做好了流尽最后一滴血的准备。",
    chapters: 140,
    views: 2890000,
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 11,
    title: "恶魔的契约",
    author: "Shin Yoo-jin",
    coverImage: "https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20webtoon%20cover%20featuring%20a%20mysterious%20man%20with%20demonic%20red%20eyes%20offering%20a%20contract%20to%20a%20desperate%20woman%2C%20gothic%20atmosphere%2C%20dramatic%20red%20and%20black%20color%20scheme%2C%20detailed%20dark%20illustration%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-11&orientation=portrait",
    rating: 9.5,
    category: "fantasy",
    tags: ["恶魔", "契约", "黑暗奇幻"],
    status: "连载中",
    updateDate: "2026-08-02",
    description: "濒死的少女在绝望中召唤了恶魔，以灵魂为代价换取了活下去的力量。然而这个恶魔似乎并不是传说中那样冷酷无情，他在人间有自己的目的，而少女成了他计划中不可或缺的棋子。",
    chapters: 88,
    views: 1890000,
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 12,
    title: "灵异调查科",
    author: "Yoon Ah-reum",
    coverImage: "https://readdy.ai/api/search-image?query=A%20Korean%20horror%20mystery%20webtoon%20cover%20showing%20investigators%20with%20flashlights%20in%20a%20dark%20abandoned%20building%2C%20eerie%20atmosphere%2C%20ghostly%20elements%2C%20cool%20greenish%20lighting%2C%20suspenseful%20composition%2C%20detailed%20thriller%20art%20on%20dark%20background&width=400&height=560&seq=comic-cover-12&orientation=portrait",
    rating: 9.2,
    category: "thriller",
    tags: ["灵异", "探案", "恐怖"],
    status: "已完结",
    updateDate: "2026-06-20",
    description: "首尔警局下属的灵异调查科，专门处理无法用科学解释的案件。队长朴志勋拥有看见鬼魂的能力，带领团队穿梭于现实与灵界之间。每一个案件背后，都藏着令人心碎的真相。",
    chapters: 96,
    views: 2210000,
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
];

export const testimonials = [
  {
    id: 1,
    name: "漫画迷小王",
    avatar: "https://readdy.ai/api/search-image?query=A%20simple%20flat%20style%20avatar%20portrait%20of%20a%20young%20Asian%20man%2C%20minimalist%20design%2C%20warm%20color%20tone%2C%20clean%20simple%20illustration%2C%20circular%20frame%20friendly%20style&width=80&height=80&seq=avatar-01&orientation=squarish",
    rating: 5,
    comment: "用了韩漫屋之后，再也不用到处找韩漫资源了！更新快、画质好，分类也很清晰，真心推荐给所有喜欢韩漫的朋友。",
  },
  {
    id: 2,
    name: "追更达人Linda",
    avatar: "https://readdy.ai/api/search-image?query=A%20simple%20flat%20style%20avatar%20portrait%20of%20a%20young%20Asian%20woman%20with%20glasses%2C%20minimalist%20design%2C%20warm%20color%20tone%2C%20clean%20simple%20illustration%2C%20circular%20frame%20friendly%20style&width=80&height=80&seq=avatar-02&orientation=squarish",
    rating: 5,
    comment: "每天必刷的网站！推荐板块总能发现新的宝藏漫画，已经成功安利给身边所有朋友了。而且完全免费，太良心了！",
  },
  {
    id: 3,
    name: "老二次元阿杰",
    avatar: "https://readdy.ai/api/search-image?query=A%20simple%20flat%20style%20avatar%20portrait%20of%20a%20young%20Asian%20man%20with%20cool%20hair%2C%20minimalist%20design%2C%20warm%20color%20tone%2C%20clean%20simple%20illustration%2C%20circular%20frame%20friendly%20style&width=80&height=80&seq=avatar-03&orientation=squarish",
    rating: 5,
    comment: "看韩漫七八年了，韩漫屋是目前体验最好的平台。界面清爽没有广告轰炸，阅读体验一流，收藏功能也很方便。",
  },
];

export const faqs = [
  {
    question: "韩漫屋上的漫画都是免费的吗？",
    answer: "是的！韩漫屋上所有漫画内容均免费提供阅读，您无需支付任何费用即可畅享精彩韩漫。我们致力于为漫画爱好者提供一个优质的免费阅读平台。",
  },
  {
    question: "漫画更新频率是怎样的？",
    answer: "我们的编辑团队每天都会更新漫画内容。热门连载漫画通常保持每周更新，部分作品可实现日更。您可以在首页的「最近更新」板块查看最新的漫画章节。",
  },
  {
    question: "如何找到我想看的漫画？",
    answer: "您可以通过多种方式找到心仪的漫画：使用首页的分类导航浏览不同类型；查看「热门排行」发现最受欢迎的漫画；也可以利用搜索功能直接搜索漫画名称或作者。",
  },
  {
    question: "支持手机阅读吗？",
    answer: "当然支持！韩漫屋采用响应式设计，完美适配手机、平板和电脑等各种设备。无论您使用什么设备，都能获得流畅舒适的阅读体验。",
  },
  {
    question: "漫画的画质如何？",
    answer: "我们提供高清画质的漫画资源，所有漫画均经过精心优化处理，确保在各类屏幕上都呈现出色的视觉效果。无论细节表现还是色彩还原，都力求达到最佳水准。",
  },
];

export const siteInfo = {
  name: "韩漫屋",
  tagline: "免费在线韩国漫画阅读平台",
  description: "韩漫屋是一个专业的免费在线漫画阅读平台，为您精心准备了精彩的韩漫大全，资源多样且画质优秀，是您探索韩漫的理想起点。",
  foundingYear: 2020,
  totalComics: 5000,
  totalUsers: 1200000,
  dailyVisitors: 80000,
  email: "contact@hanmanwu.com",
  wechat: "hanmanwu_official",
  qq: "1234567890",
};